import React from 'react';
import BlockSettings from './BlockSettings';
import { IImageGalleryProps, IImageGallery } from './utils';
import { StyledQuickEditOverlay, BackgroundImage, Title, Wrapper } from './styles';
import Gallery from './Gallery';
import usePageBlock from 'hooks/use-page-block';
import { PREDEFINED_TOOLBAR_BUTTONS } from 'components/ui/RichTextEditorV2/utils';
import { ImageGalleryProvider, useImageGalleryContext } from './ImageGalleryContext/ImageGalleryContext';

type EditableStringPaths = (
  'title' |
  'imageCards'
);

const ImageGallery: React.FC<IImageGalleryProps> = ({ onEdit, onRemove, item }) => {
  const { backgroundImage, isScrollable, title } = useImageGalleryContext();

  const handleChangeData = (update: IImageGallery) => {
    onEdit({ ...item, data: update });
  };

  const { handleChange, handleCloseSettings, handleOpenSettings, isSettingsOpen } = usePageBlock<EditableStringPaths, IImageGallery>({
    item: item.data,
    onChange: handleChangeData,
  });

  return (
    <ImageGalleryProvider item={item} onEdit={onEdit}>
      <StyledQuickEditOverlay
        backgroundColor={item.data.background.color}
        onEdit={handleOpenSettings}
        onRemove={onRemove}
        titleKey="ADMIN_LABEL_IMAGE_GALLERY"
        testId={`imageGallery-${item.arrayId}`}
      >
        <Wrapper isScrollable={isScrollable}>
          {Boolean(backgroundImage) && (
            <BackgroundImage
              src={backgroundImage}
              alt="Image Gallery Background Image"
            />
          )}
          <Title
            blockTitleKey="ADMIN_LABEL_TITLE"
            onChange={handleChange('title')}
            data={title}
            data-testid="imageGalleryTitle"
            toolbarButtons={PREDEFINED_TOOLBAR_BUTTONS.titleEditor}
            htmlTag="h2"
          />
          <Gallery />
          <BlockSettings
            isOpen={isSettingsOpen}
            item={item.data}
            onChange={handleChangeData}
            onClose={handleCloseSettings}
          />
        </Wrapper>
      </StyledQuickEditOverlay>
    </ImageGalleryProvider>
  );
};


export const ImageGalleryWrapper: React.FC<IImageGalleryProps> = props => {
  return (
    <ImageGalleryProvider item={props.item} onEdit={props.onEdit}>
      <ImageGallery {...props} />
    </ImageGalleryProvider>
  );
};

export default ImageGalleryWrapper;
